import Loader from "reusable/mobx-helpers/Loader"
import ProposalSectionAcceptanceStore from "./ProposalSectionAcceptanceStore"
import ProposalsViewProposalStore from "../../ProposalsViewProposalStore"
import DateUtils from "@gap/utils/date-utils"
import { ProposalSectionAcceptanceSigneeProps } from "./ProposalSectionAcceptanceSignee"

interface ProposalSectionAcceptanceSigneeStoreProps extends ProposalSectionAcceptanceSigneeProps {
   proposalSectionAcceptanceStore: ProposalSectionAcceptanceStore
   proposalsViewProposalStore: ProposalsViewProposalStore
}

export default class ProposalSectionAcceptanceSigneeStore {
   sp
   signLoader = new Loader()

   constructor(sp: ProposalSectionAcceptanceSigneeStoreProps) {
      this.sp = sp
   }

   get signText() {
      if (!!this.sp.signee.agreedAt) {
         return `Signed on ${DateUtils.formatDate(this.sp.signee.agreedAt, 'date-full-month')}`
      } else if (this.sp.proposalsViewProposalStore.isProposalAccepted) {
         return 'No signature received'
      } else if (!this.sp.currentUserCanSign) {
         return 'Waiting for signature'
      } else if (this.sp.proposalSectionAcceptanceStore.isReadyToSign) {
         return 'Ready to sign'
      } else {
         return 'Please select a payment option for each fee type and accept the terms to continue'
      }
   }

   get signHandlerDisabled() {
      return !this.sp.proposalSectionAcceptanceStore.isReadyToSign || !!this.sp.signee.agreedAt
   }

   signHandler = async () => {
      await this.signLoader.executeLoading(async () => {
         await this.sp.onSigned()
      })
   }
}
